import { formatPersianNumber, formatSolarDate, EmptyState } from '../../../app/components/foundation';
import { VaniaLoadingSystem, VaniaTableSkeleton } from '../../../app/components/loading';
import type { UserApiUser } from '../../users/types/user.types';

export interface TenantUsersSectionProps {
  users: UserApiUser[];
  loading: boolean;
  error: string | null;
}

export function TenantUsersSection({ users, loading, error }: TenantUsersSectionProps) {
  return (
    <div className="vania-tenant-users-content">
      <div className="vania-tenant-users-header">
        <div>
          <h2 className="vania-tenant-workspace-card-title">کاربران</h2>
        </div>
        {!loading && !error && (
          <span className="vania-tenant-users-count">{formatPersianNumber(users.length)} کاربر</span>
        )}
      </div>

      {loading ? (
        <VaniaLoadingSystem mode="content" label="در حال بارگذاری کاربران تننت">
          <VaniaTableSkeleton columns={4} rows={5} className="vania-tenant-users-skeleton" />
        </VaniaLoadingSystem>
      ) : error ? (
        <p className="vania-tenants-status vania-tenants-status-error" role="alert">{error}</p>
      ) : users.length === 0 ? (
        <EmptyState message="کاربری برای این تننت ثبت نشده است." />
      ) : (
        <div className="vania-tenant-users-table-scroll">
          <table className="vania-tenant-users-table">
            <thead>
              <tr>
                <th>کاربر تلگرام</th>
                <th>موبایل</th>
                <th>وضعیت</th>
                <th>تاریخ عضویت</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user.id}>
                  <td>
                    <span className="vania-tenant-users-name">{user.full_name || user.username || 'کاربر بدون نام'}</span>
                    <span className="vania-tenant-users-id" dir="ltr">#{formatPersianNumber(user.id)}</span>
                    <span className="vania-tenant-users-telegram" dir="ltr">{user.telegram_id}</span>
                  </td>
                  <td dir="ltr">{user.phone_number || '—'}</td>
                  <td>
                    <span className={`vania-tenant-users-status ${user.is_blocked ? 'is-blocked' : 'is-active'}`}>
                      {user.is_blocked ? 'مسدود' : 'فعال'}
                    </span>
                  </td>
                  <td dir="ltr">{formatSolarDate(user.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
